import { INamedItemInfo } from '../../models/resourceInfoParts';
import { Set } from '../../models/Set';
import { Module } from '../../Module';
import { ITypedIdWithName } from '../../ServerApi/types/ITypedId';
import {
  DatabasePermissionsEditabilityLogic,
  DataRolePermissionsEditabilityLogic,
  DatasourcePermissionsEditabilityLogic,
  FlowPermissionsEditabilityLogic,
  MetricPermissionsEditabilityLogic,
  PermissionsEditabilityLogic,
  ProjectPermissionsEditabilityLogic,
  PublishedConnectionPermissionsEditabilityLogic,
  TablePermissionsEditabilityLogic,
  ViewPermissionsEditabilityLogic,
  WorkbookPermissionsEditabilityLogic,
} from './PermissionsEditabilityLogic';

interface EditabilityLogicConstructor {
  new(
    authorizables: Set<INamedItemInfo>,
    sourceAuthorizables: _.Dictionary<ITypedIdWithName>,
    $translate: ng.translate.ITranslateService
  ): PermissionsEditabilityLogic;
}

export class PermissionsEditabilityLogicFactory {

  public static $inject = ['$translate'];

  constructor(private $translate: ng.translate.ITranslateService) {}

  private static ImplForContentType: _.Dictionary<EditabilityLogicConstructor> = {
    database: DatabasePermissionsEditabilityLogic,
    dataRole: DataRolePermissionsEditabilityLogic,
    datasource: DatasourcePermissionsEditabilityLogic,
    flow: FlowPermissionsEditabilityLogic,
    metric: MetricPermissionsEditabilityLogic,
    project: ProjectPermissionsEditabilityLogic,
    publishedConnection: PublishedConnectionPermissionsEditabilityLogic,
    table: TablePermissionsEditabilityLogic,
    view: ViewPermissionsEditabilityLogic,
    workbook: WorkbookPermissionsEditabilityLogic,
  };

  public logicForAuthorizables(
    authorizables: Set<INamedItemInfo>,
    authorizableType: string,
    sourceAuthorizables: _.Dictionary<ITypedIdWithName>
  ): PermissionsEditabilityLogic {
    const impl = PermissionsEditabilityLogicFactory.ImplForContentType[authorizableType];
    return new impl(authorizables, sourceAuthorizables, this.$translate);
  }

}

Module.instance().service('PermissionsEditabilityLogicFactory', PermissionsEditabilityLogicFactory);
